import { useEffect, useReducer, useState } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  getEpranKit,
  hideLoader,
  saveDocuments,
  saveEpranKit,
  showLoader,
} from "../../../../store/actions";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import UploadFile from "../../uploadFile";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  resetOldAccountType,
  setDocuementDetails,
} from "../Context/NewSubscriberAction";
import CustomInputField from "./lib/InputField";
import NavigationButtons from "./lib/NavigationButtons";
import { SUCCESS_RESPONSE_CODE } from ".";

const PHOTO = "photo";
const CANCELLEDCHEQUE = "cancelledCheque";
const CANCELLEDCHEQUE2 = "cancelledCheque2";
const SIGNATURE = "signature";
const PAN = "pan";

const documentSchema = {
  [PHOTO]: {
    label: "Photograph",
    type: PHOTO,
    fileType: "image/png, image/jpeg, image/jpg",
    fileSize: 2048,
    note: [
      "Photograph should be in JPG or PNG format & File size should be between 2KB and 2MB.",
    ],
  },

  [SIGNATURE]: {
    label: "Signature",
    type: SIGNATURE,
    fileType: "image/png, image/jpeg, image/jpg",
    fileSize: 2048,
    note: [
      "Signature should be in JPG or PNG format & File size should be between 2KB and 2MB.",
    ],
  },
};
const initialState = {
  photo: {},
  cancelledCheque: {},
  cancelledCheque2: {},
  signature: {},
  pan: {},
};

const EPRAN = "E";
const PHYSICAL_PRAN = "P";

const UploadDocuments = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    ackNumber: AckNumber,
    pennyDropResponse: tier1PennyDrop,
    schemeDetails: npsSchemeDetails,
    dispatch: dispatchContext,
    isBackToSummary,
    tier2PennyDrop,
    EKYCDetails = {},
    documentDetails,
  } = useNewSubscriberContext();

  const isTier1AccountValid = tier1PennyDrop?.data?.result?.bankTxnStatus;
  const isTier2AccountValid = tier2PennyDrop?.data?.result?.bankTxnStatus;

  const [pranKitType, setPranKitType] = useState(EPRAN);
  const [pranLanguage, setPranLanguage] = useState("1");

  const documentUpload = (prevState, action) => {
    const newState = { ...prevState };
    switch (action.type) {
      case PHOTO:
        newState.photo = action.payload;
        break;

      case CANCELLEDCHEQUE:
        newState.cancelledCheque = action.payload;
        break;

      case CANCELLEDCHEQUE2:
        newState.cancelledCheque2 = action.payload;
        break;

      case SIGNATURE:
        newState.signature = action.payload;
        break;
      case PAN:
        newState.pan = action.payload;
        break;
      case "SET_STATE": {
        return action.payload;
      }

      default:
        return prevState;
    }
    return newState;
  };

  const { statusCode, data } = npsSchemeDetails;

  const accountType =
    +statusCode === SUCCESS_RESPONSE_CODE && data.AccountType
      ? data.AccountType
      : "2";

  const documentList = Object.keys(documentSchema).map((_docType) => {
    return { ...documentSchema[_docType] };
  });

  const [documents, dispatchDocuments] = useReducer(
    documentUpload,
    initialState
  );

  const setDocumentData = (type, e) => {
    if (!!e.target.files[0]) {
      const file = e.target.files[0];
      var fileReader = new FileReader();
      var base64;
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target.result;
        const fileName = file.name;
        const regex =
          type === CANCELLEDCHEQUE || CANCELLEDCHEQUE2
            ? /^.+(.{1}(jpe?g|png|pdf|JPE?G|PNG|PDF))$/
            : /^.+(.{1}(jpe?g|png|jpg|JPE?G|PNG))$/;
        if (!regex.test(fileName)) {
          dispatchDocuments({
            type,
            payload: {
              name: "",
              isError: true,
              isShowError: true,
              imageData: "",
              errorMessage:
                type === CANCELLEDCHEQUE || CANCELLEDCHEQUE2
                  ? "Only files of the type jpg,png and pdf are allowed to upload"
                  : "Only files of the type jpg and png are allowed to upload",
            },
          });
          return;
        }
        const filesize = Math.floor(file.size / 1024);
        const fileSizeLimit =
          type === CANCELLEDCHEQUE || CANCELLEDCHEQUE2 || PAN ? 3072 : 2048;
        if (filesize > fileSizeLimit || filesize < 2) {
          dispatchDocuments({
            type,
            payload: {
              name: "",
              isError: true,
              isShowError: true,
              imageData: "",
              errorMessage: `File size should be between 2KB and ${
                fileSizeLimit === 2048 ? "2MB" : "3MB"
              }`,
            },
          });
          return;
        }
        dispatchDocuments({
          type,
          payload: {
            name: file.name,
            isError: false,
            isShowError: false,
            imageData: base64.split(",")[1],
            rawImage: base64,
            fileSize: `${filesize}`,
          },
        });
      };
      // read the image file as a data URL.
      fileReader.readAsDataURL(file);
    }
  };

  const uploadHandler = (type) => (e) => {
    //to persist the react synthetic event
    e.persist();
    setDocumentData(type, e);
  };

  const submit = async () => {
    try {
      dispatch(showLoader());
      const { photo, cancelledCheque, cancelledCheque2, signature, pan } =
        documents;
      let errors = [];
      if (!photo.name) {
        errors.push("Photograph is required to proceed");
        dispatchDocuments({
          type: PHOTO,
          payload: {
            name: "",
            isError: true,
            isShowError: true,
            imageData: "",
            errorMessage: "Photograph is required to proceed",
          },
        });
      }
      if (!cancelledCheque.name && !isTier1AccountValid) {
        errors.push("Bank Statement is required to proceed");
        dispatchDocuments({
          type: CANCELLEDCHEQUE,
          payload: {
            name: "",
            isError: true,
            isShowError: true,
            imageData: "",
            errorMessage: "Bank Statement is required to proceed",
          },
        });
      }
      if (accountType == 2) {
        if (!cancelledCheque2.name && !isTier2AccountValid) {
          errors.push("Bank Statement is required to proceed");
          dispatchDocuments({
            type: CANCELLEDCHEQUE2,
            payload: {
              name: "",
              isError: true,
              isShowError: true,
              imageData: "",
              errorMessage: "Bank Statement is required to proceed",
            },
          });
        }
      }
      if (!signature.name) {
        errors.push("Signature is required to proceed");
        dispatchDocuments({
          type: SIGNATURE,
          payload: {
            name: "",
            isError: true,
            isShowError: true,
            imageData: "",
            errorMessage: "Signature is required to proceed",
          },
        });
      }
      if (!pan.name && +accountType === 2) {
        errors.push("PAN is required to proceed");
        dispatchDocuments({
          type: PAN,
          payload: {
            name: "",
            isError: true,
            isShowError: true,
            imageData: "",
            errorMessage: "PAN is required to proceed",
          },
        });
      }
      if (errors.length > 0) {
        alert(errors.join("<br>"));
        return;
      }
      const data = {
        AckNumber,
        SigImage: signature.imageData,
        SignatureDocumentName: signature.name,
        SignatureDocumentSize: signature.fileSize,
        ChqImage: cancelledCheque.imageData,
        ChqDocumentName: cancelledCheque.name,
        ChqDocumentSize: cancelledCheque.fileSize,
        Tier1ChequeDocumentName: cancelledCheque2?.name,
        Tier1ChequeDocumentSize: cancelledCheque2?.fileSize,
        Tier1ChequeImage: cancelledCheque2?.imageData,
        PhotoImage: photo.imageData,
        PhotoDocumentName: photo.name,
        PhotoDocumentSize: photo.fileSize,
        ...(+accountType === 2 && {
          PanImage: pan.imageData,
          PanDocumentName: pan.name,
          PanDocumentSize: pan.fileSize,
        }),
        NRIPassport1: JSON.stringify([]),
        NRIPassport2: JSON.stringify([]),
      };
      const pranDetails = {
        AckNumber,
        Physicaldispatchrequired: pranKitType,
        EprankitLanguage: pranLanguage,
      };
      const response = await dispatch(saveDocuments(data));
      await dispatch(saveEpranKit(pranDetails));

      if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE) {
        throw new Error(response.message || "Error saving documents");
      }
      setDocuementDetails(documents)(dispatchContext);
      if (isBackToSummary) {
        resetOldAccountType(dispatchContext);
      }
      history.push("/nps/AddSubs/subscriber-summary");
    } catch (e) {
      console.error(e);
      alert(e);
    } finally {
      dispatch(hideLoader());
    }
  };

  useEffect(() => {
    if (documentDetails?.isPersisted) {
      dispatchDocuments({
        type: "SET_STATE",
        payload: documentDetails?.documents,
      });
      return;
    }

    const { IMAGE = [] } = EKYCDetails?.data?.result?.IMAGE_DETAILS || {};

    const photographDetails =
      IMAGE.find((details) => details.IMAGE_NAME === "Photograph") || {};
    const signatureDetails =
      IMAGE.find((details) => details.IMAGE_NAME === "Signature") || {};

    [photographDetails, signatureDetails]
      .filter(
        (document) =>
          !!document.IMAGE_DATA && base64SizeInBytes(document.IMAGE_DATA) < 2048
      )
      .forEach((document) => {
        dispatchDocuments({
          type: document.IMAGE_NAME === "Photograph" ? PHOTO : SIGNATURE,
          payload: {
            name: document.IMAGE_NAME,
            isError: false,
            isShowError: false,
            imageData: document.IMAGE_DATA,
            rawImage: document.IMAGE_DATA,
            fileSize: `${base64SizeInBytes(document.IMAGE_DATA)}`,
            disabled: true,
          },
        });
      });
  }, []);

  useEffect(() => {
    const fetchEpranDetails = async () => {
      try {
        const response = await getEpranKit({ AckNumber })(dispatch);
        if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE) return;
        const { data = {} } = response;
        const { EprankitLanguage, Physicaldispatchrequired } = data;
        setPranLanguage(EprankitLanguage || "1");
        setPranKitType(Physicaldispatchrequired || EPRAN);
      } catch (error) {
        alert(error);
      }
    };

    fetchEpranDetails();
  }, [AckNumber, dispatch]);

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/bank-details",
    });
  };

  return (
    <div className="container-margin">
      <CardComponent title="Upload Documents">
        <div style={{ padding: "20px 20px 0px 20px" }}>
          {documentList.map((item) => {
            const _documentType = documents[item.type];
            return (
              <div key={item.label} style={{ paddingBottom: "8px" }}>
                {item.note.map((_eachNote, index) => (
                  <div className="instruction-mode-nps" key={index}>
                    {_eachNote}
                  </div>
                ))}
                <UploadFile
                  id={item.type}
                  title={item.label}
                  uploadFile={() => uploadHandler(item.type)}
                  fileType={item.fileType}
                  fileName={_documentType.name}
                  fileSize={_documentType.fileSize}
                  isShowError={_documentType.isShowError}
                  errorMessage={_documentType.errorMessage}
                  disabled={_documentType.disabled}
                />
              </div>
            );
          })}

          {Boolean(isTier1AccountValid) ? null : (
            <div style={{ paddingBottom: "8px" }}>
              <div className="instruction-mode-nps">
                Tier I Bank Proof should be in JPG or PNG or PDF format & File
                size should be between 2KB and 3MB.
              </div>
              <UploadFile
                id={CANCELLEDCHEQUE}
                title="Cancelled Cheque / Passbook"
                uploadFile={() => uploadHandler(CANCELLEDCHEQUE)}
                fileType="image/png, image/jpeg, image/jpg"
                fileName={documents[CANCELLEDCHEQUE].name}
                fileSize={documents[CANCELLEDCHEQUE].fileSize}
                isShowError={documents[CANCELLEDCHEQUE].isShowError}
                errorMessage={documents[CANCELLEDCHEQUE].errorMessage}
              />
            </div>
          )}
          {+accountType === 2 && (
            <>
              {Boolean(isTier2AccountValid) ? null : (
                <div style={{ paddingBottom: "8px" }}>
                  <div className="instruction-mode-nps">
                    Tier II Bank Proof should be in JPG or PNG or PDF format &
                    File size should be between 2KB and 3MB.
                  </div>
                  <UploadFile
                    id={CANCELLEDCHEQUE2}
                    title="Cancelled Cheque / Passbook"
                    uploadFile={() => uploadHandler(CANCELLEDCHEQUE2)}
                    fileType="image/png, image/jpeg, image/jpg"
                    fileName={documents[CANCELLEDCHEQUE2].name}
                    fileSize={documents[CANCELLEDCHEQUE2].fileSize}
                    isShowError={documents[CANCELLEDCHEQUE2].isShowError}
                    errorMessage={documents[CANCELLEDCHEQUE2].errorMessage}
                  />
                </div>
              )}
            </>
          )}

          {+accountType === 2 && (
            <div style={{ paddingBottom: "8px" }}>
              <div className="instruction-mode-nps">
                Document should be in JPG or PNG format & File size should be
                between 2KB and 3MB."
              </div>
              <UploadFile
                id={PAN}
                title="PAN Card"
                uploadFile={() => uploadHandler(PAN)}
                fileType="image/png, image/jpeg, image/jpg"
                fileName={documents[PAN].name}
                fileSize={documents[PAN].fileSize}
                isShowError={documents[PAN].isShowError}
                errorMessage={documents[PAN].errorMessage}
              />
            </div>
          )}
        </div>
      </CardComponent>

      <div className="container-margin">
        <div className="new-investor-card">
          <div
            style={{
              fontSize: "16px",
              fontFamily: `'Roboto', sans-serif`,
              color: "#111111",
              fontWeight: 400,
              padding: "20px",
            }}
          >
            PRAN Kit Selection
          </div>
          <div>
            <CustomInputField
              type="radio"
              label="Select the desired format of PRAN kit you wish to receive"
              options={[
                {
                  label: "Digital (ePRAN)",
                  value: EPRAN,
                },
                {
                  label: "Physical",
                  value: PHYSICAL_PRAN,
                },
              ]}
              value={pranKitType}
              onChange={(e) => setPranKitType(e.target.value)}
              required={true}
            />
          </div>
          <div>
            <CustomInputField
              type="radio"
              label="Preferred Language on PRAN Card"
              options={[
                {
                  label: "English",
                  value: "1",
                },
                {
                  label: "Hindi",
                  value: "2",
                },
              ]}
              value={pranLanguage}
              onChange={(e) => setPranLanguage(e.target.value)}
              required={true}
            />
          </div>

          {pranKitType === "E" && (
            <div className="font-weight-bold" style={{ padding: "10px 20px" }}>
              Note : KCRA charges RS.4 if you opt for ePRAN Kit , It is much
              faster and safer than a written/postal communication.
            </div>
          )}
          {pranKitType === "P" && (
            <div className="font-weight-bold" style={{ padding: "10px 20px" }}>
              Note : Rs.39.36 will be charged for Account opening if you opt for
              physical PRAN Kit.
            </div>
          )}
        </div>
      </div>
      <NavigationButtons submit={submit} goBack={goBack} />
    </div>
  );
};

export default UploadDocuments;

function base64SizeInBytes(base64String) {
  const decodedData = atob(base64String);
  return Math.floor(decodedData.length / 1024);
}
